import { render, staticRenderFns } from "./FooterHome.vue?vue&type=template&id=97ff0d7c&"
import script from "./FooterHome.vue?vue&type=script&lang=js&"
export * from "./FooterHome.vue?vue&type=script&lang=js&"
import style0 from "./FooterHome.vue?vue&type=style&index=0&id=97ff0d7c&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97ff0d7c')) {
      api.createRecord('97ff0d7c', component.options)
    } else {
      api.reload('97ff0d7c', component.options)
    }
    module.hot.accept("./FooterHome.vue?vue&type=template&id=97ff0d7c&", function () {
      api.rerender('97ff0d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/PageChild/FooterHome.vue"
export default component.exports